import './SingleStackedBar.scss';

import React from 'react';
import classnames from 'classnames';

interface Props {
  items: {
    id: string;
    value: number;
    color: string;
  }[];
  total?: number | null;
  showPercentLabels?: boolean;
  onClick?(id: string): void;
}

const SingleStackedBar: React.FC<Props> = (props) => {
  const { items, showPercentLabels, onClick } = props;

  const total =
    props.total != null
      ? props.total
      : items.reduce((total, item) => total + item.value, 0);

  return (
    <div className="SingleStackedBar">
      {items.map((item) => {
        const width = `${(item.value / total) * 100}%`;
        const percent = Math.round((item.value / total) * 100);

        return (
          <div
            className={classnames('SingleStackedBar-segment', {
              'SingleStackedBar-segment--clickable': onClick != null
            })}
            key={item.id}
            style={{ background: item.color, width }}
            onClick={
              onClick
                ? () => {
                    onClick(item.id);
                  }
                : undefined
            }
          >
            {showPercentLabels && percent > 0 && (
              <div className="SingleStackedBar-segment-label">{percent}%</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

SingleStackedBar.defaultProps = {
  showPercentLabels: true
};

export default SingleStackedBar;
